import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

let ICONS = {
    stats: (
        <img src="/img/telegram/menu/sgt-tgr-stats-gray.png" alt="stats" />
    ),
    groups: (
        <img src="/img/telegram/menu/sgt-tgr-groups-gray.png" alt="stats" />
    ),
    signals: (
        <img src="/img/telegram/menu/sgt-tgr-signals-gray.png" alt="stats" />
    ),
    tasks: (
        <img src="/img/telegram/menu/sgt-tgr-tasks-gray.png" alt="stats" />
    ),
    wallet: (
        <img src="/img/telegram/menu/sgt-tgr-wallet-gray.png" alt="stats" />
    ),
};


let defaultItems = [
    { key: "stats", label: "Stats", icon: ICONS.stats, url: "/stats" },
    { key: "groups", label: "Groups", icon: ICONS.groups, url: "/calls" },
    { key: "signals", label: "Signals", icon: ICONS.signals, url: "/signals" },
    { key: "tasks", label: "Tasks", icon: ICONS.tasks, url: "/tasks" },
    { key: "wallet", label: "Wallet", icon: ICONS.wallet, url: "/wallet"  },
];

const footerStyle = {
    display: "flex",
    gap: 8,
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
};

const groupStyle = { display: "flex", gap: 6, alignItems: "center", width: "100%", justifyContent: "space-evenly"   };

const buttonBase = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    padding: "6px 10px",
    borderRadius: 8,
    border: "none",
    background: "transparent",
    color: "#808991",
    cursor: "pointer",
    fontSize: 12,
    lineHeight: 1,
};

const activeStyle = {
    background: "linear-gradient(180deg, rgba(29,161,242,0.12), rgba(29,161,242,0.06))",
    color: "var(--tg-accent, #1DA1F2)",
    boxShadow: "inset 0 -1px 0 rgba(0,0,0,0.03)",
};



export default function TelegramFooter({ items = defaultItems, onSelect }) {
    //const navigate = useNavigate();
    const [active, setActive] = useState(items[2]?.key || null);

    const changeActiveMenuImageUrl = () => {
        // remove siblings element active class
        let elements = document.querySelectorAll('.tgr-footer-menu-button');
        if(elements.length > 0) {
            elements.forEach((el) => {
                let img = el.querySelector('img');
                if(img.getAttribute('src').indexOf('blue') !== -1) {
                    let newSrcAttr =  img.getAttribute('src').replace('blue', 'gray');
                    img.setAttribute('src', newSrcAttr);
                }
            })
        }
        // add active class
        let currentElement = document.querySelector('.tgr-footer-menu-button.active img');
        const oldSrc = currentElement.getAttribute('src');
        const newSrc = oldSrc.replace('gray', 'blue');
        currentElement.setAttribute('src', newSrc);
    }

    useEffect(() => {
        changeActiveMenuImageUrl();
    },[active])

    function handleSelect(key) {
        setActive(key);
        if (typeof onSelect === "function") onSelect(key);
        const location = items.find((it) => it.key === key)?.url;
        console.log('location', location);
        if(location) {
            window.location.href = location;
            //navigate(location);
        }
    }

    return (
        <nav aria-label="Telegram footer menu" className="tgr-footer-menu" style={footerStyle}>
            <div style={groupStyle}>
                {items.map((it) => {
                    const isActive = it.key === active;
                    return (
                        <button
                            key={it.key}
                            onClick={() => handleSelect(it.key)}
                            aria-pressed={isActive}
                            title={it.label}
                            className={`tgr-footer-menu-button ${isActive ? 'active' : ''}`}
                            style={buttonBase}
                        >
                            <span style={{ display: "block", color: "inherit" }}>{it.icon}</span>
                            <a className="tgr-footer-menu-link" href={it.url} style={{"textDecoration": "none"}} >{it.label}</a>

                            {/* <span className="tgr-footer-menu-link" onclick={navigate(it.url)} >{it.label}</span> */}
                            {/* <Link to={it.url}>{it.label}</Link> */}
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}